import React, {ReactElement, useRef} from 'react';
import Button from '../../../../incase-domain/components/button/Button';
import AnswerComment from './AnswerComment';
import {getAnswerColors} from '../common/utils';

export enum AnswerTypes {
    SELECTED = 'marked',
    CORRECT = 'correct',
    INCORRECT = 'incorrect',
    DEBATABLE = 'debatable',
    NONE = 'none',
}

interface QuestionAnswerProps {
    answer: string;
    answerType: AnswerTypes;
    comment?: string;
    leadingIcon?: string;
    onClick: () => void;
    correctColor?: string;
    incorrectColor?: string;
    debatableColor?: string;
    writeAnswerIndices?: boolean;
    index?: number;
    styles?: React.CSSProperties;
    showComment?: boolean;
    setShowComment?: (show: boolean) => void;
}

function QuestionAnswer({
    answer,
    answerType,
    comment,
    leadingIcon,
    onClick,
    correctColor,
    incorrectColor,
    debatableColor,
    writeAnswerIndices,
    index,
    styles,
    showComment = false,
    setShowComment,
}: QuestionAnswerProps): ReactElement {
    const answerRef = useRef<HTMLDivElement>(null);

    const {getBtnAnswerColor, getCustomAnswerColor, getCustomAnswerColorWithAlpha} = getAnswerColors(
        answerType,
        correctColor,
        incorrectColor,
        debatableColor
    );

    const getLeadingIcon = (): string => {
        if (leadingIcon === 'checkbox') {
            if (answerType !== AnswerTypes.NONE) {
                return 'solar:check-square-bold';
            }
            return 'solar:stop-linear';
        }
        return leadingIcon || '';
    };

    function getAnswerText(): string {
        if (index === undefined) return answer;
        return writeAnswerIndices ? `${String.fromCharCode('A'.charCodeAt(0) + index)}: ${answer}` : answer;
    }

    return (
        <div className={`c-questionElement__answer ${showComment ? 'has-comment-open' : ''}`} ref={answerRef}>
            <Button
                variant="soft"
                color={getBtnAnswerColor()}
                customColor={getCustomAnswerColorWithAlpha(0.35)}
                customIconColor={getCustomAnswerColor()}
                size="md"
                leading={getLeadingIcon()}
                align="left"
                onClick={onClick}
                dynamicSize
            >
                <div style={styles}>{getAnswerText()}</div>
            </Button>

            {comment && <AnswerComment comment={comment} showComment={showComment} setShowComment={setShowComment} anchorRef={answerRef} />}
        </div>
    );
}

export default QuestionAnswer;
